'use client'

import { useEffect } from 'react'

import { AppErrorFallback } from '@/components/misc/app-error-fallback'
import {
  isStaleClientBundleError,
  reloadOnceForStaleClientBundle,
  reloadStaleClientBundle,
} from '@/lib/client/stale-client-bundle'
import { reportClientCrash } from '@/lib/ops/report-client-crash'

import './globals.css'

interface GlobalErrorPageProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalErrorPage({
  error,
  reset,
}: GlobalErrorPageProps) {
  const isStaleBundle = isStaleClientBundleError(error)

  useEffect(() => {
    reportClientCrash(error, {
      digest: error.digest,
      source: 'global-error',
    })
    reloadOnceForStaleClientBundle(error)
  }, [error])

  return (
    <html lang="en" suppressHydrationWarning>
      <body className="font-sans antialiased">
        <AppErrorFallback
          title="Something went wrong"
          description={
            isStaleBundle
              ? 'This page was open across an update. Reload to pick up the current version.'
              : 'The application failed to load. Try again, or return home if the problem continues.'
          }
          digest={error.digest}
          onRetry={isStaleBundle ? reloadStaleClientBundle : reset}
        />
      </body>
    </html>
  )
}
